/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PremiumDueResponseDto } from './PremiumDueResponseDto';
import {
    PremiumDueResponseDtoFromJSON,
    PremiumDueResponseDtoFromJSONTyped,
    PremiumDueResponseDtoToJSON,
    PremiumDueResponseDtoToJSONTyped,
} from './PremiumDueResponseDto';
import type { PaginationDto } from './PaginationDto';
import {
    PaginationDtoFromJSON,
    PaginationDtoFromJSONTyped,
    PaginationDtoToJSON,
    PaginationDtoToJSONTyped,
} from './PaginationDto';

/**
 * 
 * @export
 * @interface PremiumDuePaginationResponseDto
 */
export interface PremiumDuePaginationResponseDto {
    /**
     * 
     * @type {PaginationDto}
     * @memberof PremiumDuePaginationResponseDto
     */
    pagination: PaginationDto;
    /**
     * 
     * @type {Array<PremiumDueResponseDto>}
     * @memberof PremiumDuePaginationResponseDto
     */
    items: Array<PremiumDueResponseDto>;
}

/**
 * Check if a given object implements the PremiumDuePaginationResponseDto interface.
 */
export function instanceOfPremiumDuePaginationResponseDto(value: object): value is PremiumDuePaginationResponseDto {
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function PremiumDuePaginationResponseDtoFromJSON(json: any): PremiumDuePaginationResponseDto {
    return PremiumDuePaginationResponseDtoFromJSONTyped(json, false);
}

export function PremiumDuePaginationResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PremiumDuePaginationResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'pagination': PaginationDtoFromJSON(json['pagination']),
        'items': ((json['items'] as Array<any>).map(PremiumDueResponseDtoFromJSON)),
    };
}

export function PremiumDuePaginationResponseDtoToJSON(json: any): PremiumDuePaginationResponseDto {
    return PremiumDuePaginationResponseDtoToJSONTyped(json, false);
}

export function PremiumDuePaginationResponseDtoToJSONTyped(value?: PremiumDuePaginationResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pagination': PaginationDtoToJSON(value['pagination']),
        'items': ((value['items'] as Array<any>).map(PremiumDueResponseDtoToJSON)),
    };
}

